module.exports = "pegasus/assets/advanced-image-text-header-preview.png";